const skillList = [
  { skill_name: "BruteSSH", skill_level: 0, damage: 20 },
  {
    skill_name: "FTPCrack",
    skill_level: 20,
    damage: 200,
  },
  {
    skill_name: "RelaySMTP",
    skill_level: 50,
    damage: 500,
  },
  { skill_name: "Sanatize Input", skill_level: 75, damage: -50 },
  {
    skill_name: "HTTPworm",
    skill_level: 100,
    damage: 1000,
  },
  {
    skill_name: "SQLinject",
    skill_level: 1000,
    damage: 10000,
  },
];

export { skillList };
